import React from 'react'
import PropTypes from 'prop-types'
import GCGHolidayIcon from '../Icons/GcgHolidayIcon'
import getSeasonalLogo from '../../../utils/isHolidaySeason'
import {
    DEFAULT_LOGO_URL,
    FATHERS_DAY_LOGO_URL,
    MOTHERS_DAY_LOGO_URL,
    VALENTINES_LOGO_URL,
} from '../../../utils/holidayLogoConstants'

const SEASONAL_IMG_LOGOS = {
    valentines: { src: VALENTINES_LOGO_URL, alt: "Valentine's Brand Logo" },
    mothers: { src: MOTHERS_DAY_LOGO_URL, alt: "Mother's Day Brand Logo" },
    fathers: { src: FATHERS_DAY_LOGO_URL, alt: "Father's Day Brand Logo" },
}

const SeasonalLogo = ({ className, logoImage }) => {
    const season = getSeasonalLogo()

    if (season === 'christmas') {
        return <GCGHolidayIcon className={className} />
    }

    const seasonal = SEASONAL_IMG_LOGOS[season]
    if (seasonal) {
        return (
            <img className={className} src={seasonal.src} alt={seasonal.alt} />
        )
    }

    return (
        <img
            className={className}
            src={logoImage || DEFAULT_LOGO_URL}
            alt="Brand Logo"
        />
    )
}

SeasonalLogo.propTypes = {
    className: PropTypes.string,
    logoImage: PropTypes.string,
}

export default SeasonalLogo
